import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { getUserReportsTo } from "../../api/users/getUserReportsTo";
import { useAuthContext } from "../../hooks";
import PeopleLeadSc from "./index.sc";
import Modal from "react-bootstrap/Modal";
import { useForm } from "react-hook-form";
import { createPeopleLead } from "../../api/Admin/createPeopleLead";
import { getUsers } from "../../api/users/getUsers";
import { updatePeopleLeadPosition } from "../../api/Admin/updatePeopleLeadPosition";
import { removePeopleLead } from "../../api/PeopleLeadAccess/removePeoplead";
function Index() {
  const auth = useAuthContext();

  const [reportsTo, SetReportsTo] = useState<any>([]);
  const fetchAllReportsTo = async () => {
    await getUserReportsTo(auth?.userInfo?.orgs[0]?.id)
      .then((e) => {
        console.log(e);
        SetReportsTo(e);
      })
      .catch((e) => console.log(e));
  };
  const [users, Setusers] = useState<any[]>([]);
  const fetchAllUsers = async () => {
    await getUsers(auth?.userInfo?.orgs[0]?.id)
      .then((e) => {
        console.log(e);
        Setusers(e);
      })
      .catch((e) => console.log(e));
  };
  useEffect(() => {
    fetchAllReportsTo();
    fetchAllUsers();
  }, []);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);
  // handleCHnage functions//
  const [formdata, setFormData] = useState<any>({
    org_user_id: "",
  });
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  const handleSubmitCreatePl = async (e: any) => {
    e.preventDefault();

    try {
      const response = await createPeopleLead(
        auth?.userInfo?.orgs[0]?.id,
        (auth?.userInfo?.orgs_user_id[0]).toString(),
        formdata
      );
      console.log(response);

      setFormData({ org_user_id: "" });
      setShow(false);
    } catch (error) {
      console.log(error);
    }
  };
  // update pl//
  const [formdata1, setFormData1] = useState<any>({
    f_org_user_id: "",
    t_org_user_id: "",
  });
  const handleUpdatePlChange = (e: any) => {
    const { name, value } = e.target;
    setFormData1((prevFormData: any) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  const handleUpdatePl = async (e: any) => {
    e.preventDefault();
    try {
      const response = await updatePeopleLeadPosition(
        auth?.userInfo?.orgs[0]?.id,
        (auth?.userInfo?.orgs_user_id[0]).toString(),
        formdata1
      );
      console.log(response);

      setFormData1({ org_user_id: "" });
      setShow1(false);
    } catch (error) {
      console.log(error);
    }
  };
  const [formdata3, setFormData3] = useState<any>({
    org_user_id: "",
  });
  const handleRemovePlChange = (e: any) => {
    const { name, value } = e.target;
    setFormData3((prevFormData: any) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  const handleRemovePl = async (e: any) => {
    e.preventDefault();
    try {
      const response = await removePeopleLead(
        auth?.userInfo?.orgs[0]?.id,
        (auth?.userInfo?.orgs_user_id[0]).toString(),
        formdata3
      );
      console.log(response);

      setFormData3({ org_user_id: "" });
      setShow2(false);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <PeopleLeadSc>
      <div className="button_class">
        <Button onClick={handleShow}>Create PL</Button>
        <Button onClick={handleShow1}>Change PL</Button>
        <Button onClick={handleShow2}>Remove PL</Button>
      </div>
      <div className="emp-table">
        <label>Existng People Lead</label>
        <table>
          <tr>
            <th className="heading">S.no</th>
            <th className="heading">Name</th>
          </tr>
          {reportsTo &&
            reportsTo?.map((data: any, idx: any) => {
              return (
                <>
                  <tr>
                    <td>{idx + 1}</td>
                    <td>{data?.Name}</td>
                  </tr>
                </>
              );
            })}
        </table>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <form onSubmit={handleSubmitCreatePl}>
          <Modal.Header closeButton>
            <Modal.Title>Create People Lead</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <select
              aria-label="Default select example"
              onChange={handleChange}
              name="org_user_id"
            >
              <option value="">Select Employee</option>
              {users
                ?.filter(
                  (data: any) =>
                    data?.is_people_lead === 0 ||
                    data?.is_people_lead === "null"
                )
                .map((data: any) => (
                  <option value={data?.org_user_id}>
                    {data?.first_name + " " + data?.last_name}
                  </option>
                ))}
            </select>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" type="submit">
              Make PL
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
      <Modal
        show={show1}
        onHide={handleClose1}
        backdrop="static"
        keyboard={false}
      >
        <form onSubmit={handleUpdatePl}>
          <Modal.Header closeButton>
            <Modal.Title>Create People Lead</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <label>Existing People Lead</label>
            <Form.Select
              aria-label="Default select example"
              onChange={handleUpdatePlChange}
              name="f_org_user_id"
            >
              <option value="">Select Employee</option>
              {reportsTo &&
                reportsTo?.map((data: any, idx: any) => {
                  return (
                    <>
                      <option value={data?.org_user_id}>{data?.Name}</option>
                    </>
                  );
                })}
            </Form.Select>
            <label>New People lead</label>
            <Form.Select
              aria-label="Default select example"
              onChange={handleUpdatePlChange}
              name="t_org_user_id"
            >
              <option value="">Select Employee</option>
              {users
                ?.filter(
                  (data: any) =>
                    data?.is_people_lead === 0 ||
                    data?.is_people_lead === "null"
                )
                .map((data: any) => (
                  <option value={data?.org_user_id}>
                    {data?.first_name + " " + data?.last_name}
                  </option>
                ))}
            </Form.Select>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose1}>
              Close
            </Button>
            <Button variant="primary" type="submit">
              Make PL
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
      <Modal
        show={show2}
        onHide={handleClose2}
        backdrop="static"
        keyboard={false}
      >
        <form onSubmit={handleRemovePl}>
          <Modal.Header closeButton>
            <Modal.Title>Create People Lead</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <label>Remove People Lead</label>
            <Form.Select
              aria-label="Default select example"
              onChange={handleRemovePlChange}
              name="org_user_id"
            >
              {reportsTo &&
                reportsTo?.map((data: any, idx: any) => {
                  return (
                    <>
                      <option value={data?.org_user_id}>{data?.Name}</option>
                    </>
                  );
                })}
            </Form.Select>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose2}>
              Close
            </Button>
            <Button variant="primary" type="submit">
              Remove PL
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </PeopleLeadSc>
  );
}

export default Index;
// modified_org_user_id=path_param.get('org_user_id'),
//         org_user_id =body.get('org_user_id')
